export default "<p>\n  Hier entsteht bald die Detailseite zu unserem B-Wurf.\n</p>\n";